import React from 'react';
import PropTypes from 'prop-types';
import { CascaderSelect } from 'mkui-ext';
import { replaceKeys } from '../_util/jsonUtils';

// 预设的热门城市：
// 北京(ZH1_0_00)、上海(ZH4_0_00)、广州(ZH9_4_01)、深圳(ZH9_15_01)、杭州(ZH32_1_01)、
// 天津(ZH2_0_00)、成都(ZH28_3_01)、重庆(ZH33_0_00)、哈尔滨(ZH15_3_01)、南京(ZH19_4_01)
const defaultFrequent = [
  'ZH1_0_00',
  'ZH4_0_00',
  'ZH9_4_01',
  'ZH9_15_01',
  'ZH32_1_01',
  'ZH2_0_00',
  'ZH28_3_01',
  'ZH33_0_00',
  'ZH15_3_01',
  'ZH19_4_01',
];

// 需要替换的key
const replaceKeyMap = {
  countryCode: 'value',
  provinceCode: 'value',
  cityCode: 'value',
  regionCode: 'value',
  countryName: 'label',
  provinceName: 'label',
  cityName: 'label',
  regionName: 'label',
  provinces: 'children',
  cities: 'children',
  regions: 'children',
};

class AddressSelect extends React.Component {
  /** *******************static************************** */
  static propTypes = {
    onChange: PropTypes.func,
    api: PropTypes.func,
    value: PropTypes.object,
    frequentStorageKey: PropTypes.string,
  };

  static defaultProps = {
    onChange: null,
    api: null,
    value: null,
    frequentStorageKey: 'often.place',
  };

  /** *******************life cycle************************** */

  /** *******************handle************************** */

  /** *******************inner method************************** */
  formatData = (data) => {
    const domestic = data.domestic;
    const countries = [...data.abroad.countries];
    countries.unshift({
      countryCode: domestic.code,
      countryName: domestic.name,
      provinces: domestic.provinces,
    });
    return countries;
  }

  apiAdapter = () => {
    const { api } = this.props;
    return new Promise((resolve) => {
      api().then((res) => {
        let data = this.formatData(res);
        data = replaceKeys(data, replaceKeyMap);
        resolve(data);
      });
    });
  }

  /** *******************render************************** */
  render() {
    const { value, onChange, disabled, frequentStorageKey } = this.props;
    return (
      <CascaderSelect
        api={this.apiAdapter}
        disabled={disabled}
        lazyLoad
        hasFrequent
        defaultFrequent={defaultFrequent}
        frequentStorageKey={frequentStorageKey}
        value={value}
        placeholder="请选择"
        searchPlaceholder="请输入城市名称、拼音或简称，如：杭州，Hangzhou，HZ"
        onChange={onChange}
      />
    );
  }
}

export default AddressSelect;
